import { cn } from '@/shared/ui/cn';

export type SpinnerProps = {
  /** Côté en pixels. 18 dans un bouton, 24 au centre d'un bloc. */
  size?: number;
  className?: string;
  /** Lu par un lecteur d'écran ; absent, l'attente est annoncée par l'appelant. */
  label?: string;
};

/**
 * Attente courte : un trait qui tourne, dans la couleur du texte. Une attente
 * longue (un écran qui charge) se dit avec un squelette, jamais avec un
 * tourniquet seul au milieu du vide.
 */
export function Spinner({ size = 18, className, label }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      className={cn('animate-spin', className)}
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.22" strokeWidth="2.2" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
